import { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useHistory, useLocation } from "react-router-dom";

import ModalLance from "./ModalOrganizacoes/";

import {
    LoginOrganizacao,
    Login,
} from "../../../Interfaces/Login/LoginInterface";
import { Organizacao } from "../../../Interfaces/Login/OrganizacaoInterface";

import { replaceClass } from "../../../Tools/Classtools";

import {
    ListarOrganizacaoController,
    LoginOrganizacaoController,
    LoginUser,
} from "../../../Controllers/Login/LoginController";
import { useUserInfor } from "../../../Context/User";
import { GetOrganizacaoController } from "../../../Controllers/Organizacao/Organizacao";
import {
    GetUserInfor,
    RegisterAuthorizeController,
} from "../../../Controllers/Users/UsersController";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWindows } from "@fortawesome/free-brands-svg-icons";
import { useMsal } from "@azure/msal-react";
import {
    FazerLoginADController,
    FazerLoginOrganizacaoADController,
    LoginMSAL,
} from "../../../Controllers/Login/LoginAD/LoginADControllers";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import { Spinner } from "../../../Components/Loding/SpinnerPadrao";
import { useEffect } from "react";
import StorageManagerCapys from "../../../Tools/Storage";
import { ACESSOS } from "../../../Routes/Acessos";
import { RegisterUserInterface } from "../../../Interfaces/Users/UsersInterface";
import LazySelect from "../../../Components/CardsPages/Forms/LazySelect";
import { ListarEquipesDeVendasSemLoginController } from "../../../Controllers/Vendas/EquipeVendas/EquipeVendasControllers";
import { formatterCPF_CNPJ } from "../../../Validations/InputMasks";

interface ILogin extends LoginOrganizacao {
    token_msal: string;
}

const modulos = [
    {
        ID_MODULO: ACESSOS.ATENDIMENTO.ID_MODULO,
        DS_MODULO: ACESSOS.ATENDIMENTO.DS_BASE_URL,
    },
    {
        ID_MODULO: ACESSOS.COBRANCA.ID_MODULO,
        DS_MODULO: ACESSOS.COBRANCA.DS_BASE_URL,
    },
    {
        ID_MODULO: ACESSOS.ASSISTENCIA.ID_MODULO,
        DS_MODULO: ACESSOS.ASSISTENCIA.DS_BASE_URL,
    },
    {
        ID_MODULO: ACESSOS.VENDAS.ID_MODULO,
        DS_MODULO: ACESSOS.VENDAS.DS_BASE_URL,
    },
    {
        ID_MODULO: ACESSOS.REPASSE.ID_MODULO,
        DS_MODULO: ACESSOS.REPASSE.DS_BASE_URL,
    },
    {
        ID_MODULO: ACESSOS.ENTREGA_DE_CHAVES.ID_MODULO,
        DS_MODULO: ACESSOS.ENTREGA_DE_CHAVES.DS_BASE_URL,
    },
    {
        ID_MODULO: ACESSOS.HELPDESK.ID_MODULO,
        DS_MODULO: ACESSOS.HELPDESK.DS_BASE_URL,
    },
    {
        ID_MODULO: ACESSOS.AUTOMACAO.ID_MODULO,
        DS_MODULO: ACESSOS.AUTOMACAO.DS_BASE_URL,
    },
];

export function LoginForm() {
    const { instance } = useMsal();

    const location = useLocation();
    const isSSOnlyPage = location.pathname.includes("/sso");

    const [StatusModal, setStatusModal] = useState(false);

    const { setUserInfor, setOrgInfor, updateConfig } = useUserInfor();

    const FormMethods = useForm();

    const { register, handleSubmit, formState, getValues } = FormMethods;

    const [lstOrganizacoes, setLstOrganizacoes] =
        useState<Array<Organizacao>>();
    const [Usuario, setUsuario] = useState<LoginOrganizacao>();
    const [tokenMSAL, setTokenMSAL] = useState<string>();

    const encodedData = localStorage.getItem("userData");
    const loginEncodedData = encodedData
        ? JSON.parse(atob(encodedData ?? ""))
        : null;

    const history = useHistory();

    useEffect(() => {
        const storageManagerDefaultSSO = new StorageManagerCapys(
            "DEFAULT_LOGIN_ONLY_SSO"
        );
        if (isSSOnlyPage) storageManagerDefaultSSO.set(true);
        else storageManagerDefaultSSO.remove();
    }, [isSSOnlyPage]);

    const Login = async (data: ILogin) => {
        const LoginOrgPromise = data.token_msal
            ? FazerLoginOrganizacaoADController(data.token_msal)
            : LoginOrganizacaoController(data);
        await LoginOrgPromise.then(async (response) => {
            setLstOrganizacoes(response);
            setUsuario(data);
            if (response.length > 1) {
                setStatusModal(true);
            } else {
                const user: Login = {
                    Email: data.Email,
                    Password: data.Password,
                    IDOrganizacao: response[0].ID_ORGANIZACAO,
                };

                const LoginUserPromise = data.token_msal
                    ? FazerLoginADController(
                          data.token_msal,
                          user.IDOrganizacao
                      )
                    : LoginUser(user);
                await LoginUserPromise.then((token) => {
                    history.push("/Geral");
                    GetOrganizacaoController().then((res) => {
                        setOrgInfor(res);

                        GetUserInfor().then((response) => {
                            setUserInfor({ ...response, token });
                            if (response.ID_MODULO_PRINCIPAL) {
                                history.push(
                                    `${
                                        modulos.find(
                                            (modulo) =>
                                                modulo.ID_MODULO ===
                                                response.ID_MODULO_PRINCIPAL
                                        )?.DS_MODULO
                                    }`
                                );
                            } else if (loginEncodedData.FL_ULTIMO_MODULO) {
                                if (
                                    String(loginEncodedData?.ID_ORGANIZACAO) ===
                                        String(res.ID_ORGANIZACAO) &&
                                    Number(loginEncodedData?.ID_USUARIO) ===
                                        Number(response.ID_USUARIO) &&
                                    String(loginEncodedData?.ultimaUrl).length >
                                        0
                                ) {
                                    history.push(
                                        `/${loginEncodedData.ultimaUrl}`
                                    );
                                } else {
                                    history.push("/Geral");
                                }
                            } else {
                                history.push("/Geral");
                            }
                        });
                    });
                    updateConfig();
                }).catch((err) => {
                    console.log(err);
                });
            }
        }).catch((err) => {});
    };

    const { execute: LoginAD, loading: loadingAD } = useAsyncCallback(
        async () => {
            try {
                const msal_token = await LoginMSAL(instance);
                setTokenMSAL(msal_token);
                await Login({
                    Email: "",
                    Password: "",
                    token_msal: msal_token,
                });
            } catch (error) {
                console.log(
                    "Usuário não efetuou login microsoft - " +
                        (error as any)?.message
                );
            }
        }
    );

    const { execute: onSubmit, loading } = useAsyncCallback(Login);

    const { execute: registerUser, loading: registerUserLoading } =
        useAsyncCallback(RegisterAuthorizeController);

    function handleCriarUsuario(formData: RegisterUserInterface) {
        const cleanCPF = formData.DS_CPF.replace(/[.-]/g, "");
        console.log(cleanCPF);
        registerUser(
            {
                ...formData,
                FL_ATIVO: false,
                NR_CPF: cleanCPF,
                FL_ADMINISTRADOR: false,
                DS_LOGIN: formData.DS_EMAIL,
            },
            formData.ID_ORGANIZACAO,
            0
        ).then(() => {
            setIsCreatingAccount(false);
        });
    }

    const [isCreatingAccount, setIsCreatingAccount] = useState(false);

    const handleCreateAccount = () => {
        setIsCreatingAccount(true);
    };

    const handleBackToLogin = () => {
        setIsCreatingAccount(false);
    };

    return (
        <div className="login-form login-signin">
            <div className="text-center mb-10 mb-lg-20">
                <h2 className="font-weight-bold">
                    {isCreatingAccount ? "Criar Conta" : "Login"}
                </h2>
                <p className="text-muted font-weight-bold">
                    {isCreatingAccount
                        ? "Preencha os campos abaixo para criar sua conta."
                        : isSSOnlyPage
                        ? "Entre com sua conta Microsoft"
                        : "Entre com seu email e senha"}
                </p>
            </div>

            {!isCreatingAccount ? (
                <>
                    <form
                        className="form"
                        id="kt_login_signin_form"
                        onSubmit={handleSubmit(onSubmit)}
                    >
                        {!isSSOnlyPage && (
                            <>
                                <div className="form-group py-3 m-0">
                                    <input
                                        className={`form-control h-auto border-0 px-0 placeholder-dark-75 ${
                                            formState.errors.Email &&
                                            "is-invalid"
                                        }`}
                                        type="Email"
                                        placeholder="Email"
                                        name="Email"
                                        ref={register({
                                            required: "Insira o seu e-mail",
                                        })}
                                    />
                                    <div className="invalid-feedback">
                                        {formState.errors.Email?.message}
                                    </div>
                                </div>
                                <div className="form-group py-3 border-top m-0">
                                    <input
                                        className={`form-control h-auto border-0 px-0 placeholder-dark-75 ${
                                            formState.errors.Password
                                                ? "is-invalid"
                                                : ""
                                        }`}
                                        id="loginFormPassword"
                                        type="Password"
                                        placeholder="Password"
                                        ref={register({
                                            required: "Insira a sua senha",
                                        })}
                                        name="Password"
                                    />
                                    <div className="invalid-feedback">
                                        {formState.errors.Password?.message}
                                    </div>
                                </div>
                                <div className="d-flex flex-wrap g-5 justify-content-center alig-items-end">
                                    <div className="form-group d-flex flex-wrap justify-content-between align-items-center">
                                        <span
                                            aria-disabled={loading}
                                            id="kt_login_forgot"
                                            role={
                                                !loading ? "button" : undefined
                                            }
                                            onClick={() => {
                                                if (!loading) {
                                                    replaceClass(
                                                        "kt_login",
                                                        "login-signin-on",
                                                        "login-forgot-on"
                                                    );
                                                }
                                            }}
                                            className="text-muted text-hover-primary"
                                        >
                                            Esqueceu sua senha?
                                        </span>
                                    </div>
                                    <div className="form-group flex-grow-1 d-flex justify-content-end">
                                        <button
                                            type="submit"
                                            id="kt_login_signin_submit"
                                            className="btn btn-capys font-weight-bold px-9 py-4 my-3 d-flex g-2 align-items-center"
                                            disabled={loading || loadingAD}
                                        >
                                            Entrar
                                            {loading && (
                                                <Spinner
                                                    color="light"
                                                    size="sm"
                                                />
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </>
                        )}
                        <div className="my-5">
                            <button
                                className="btn btn-outline-dark d-flex w-100 g-2 align-items-center justify-content-center"
                                onClick={LoginAD}
                                type="button"
                                disabled={loading || loadingAD}
                            >
                                {loadingAD ? (
                                    <Spinner size="sm" />
                                ) : (
                                    <FontAwesomeIcon icon={faWindows} />
                                )}
                                Login pela Azure
                            </button>

                            <div className="text-center mt-4">
                                <span className="text-muted">
                                    Não tem uma conta?
                                </span>{" "}
                                <button
                                    className="btn btn-link text-primary m-0 p-0 underline"
                                    type="button"
                                    onClick={handleCreateAccount}
                                >
                                    Criar Conta
                                </button>
                            </div>
                        </div>
                    </form>
                </>
            ) : (
                <>
                    <FormProvider {...FormMethods}>
                        <form
                            className="form"
                            id="kt_login_signin_form"
                            onSubmit={handleSubmit(handleCriarUsuario)}
                        >
                            <div className="row">
                                <div className="col-md-6 form-group py-3 m-0">
                                    <input
                                        className={`form-control h-auto border-0 px-0 placeholder-dark-75 ${
                                            formState.errors.DS_NOME &&
                                            "is-invalid"
                                        }`}
                                        type="text"
                                        placeholder="* Nome"
                                        name="DS_NOME"
                                        ref={register({
                                            required: "Insira o seu nome",
                                        })}
                                    />
                                    <div className="invalid-feedback">
                                        {formState.errors.DS_NOME
                                            ? formState.errors.DS_NOME.message
                                            : ""}
                                    </div>
                                </div>
                                <div className="col-md-6 form-group py-3 m-0">
                                    <input
                                        className={`form-control h-auto border-0 px-0 placeholder-dark-75 ${
                                            formState.errors.DS_EMAIL &&
                                            "is-invalid"
                                        }`}
                                        type="email"
                                        placeholder="* Email"
                                        name="DS_EMAIL"
                                        ref={register({
                                            required: "Insira o seu e-mail",
                                        })}
                                    />
                                    <div className="invalid-feedback">
                                        {formState.errors.DS_EMAIL
                                            ? formState.errors.DS_EMAIL.message
                                            : ""}
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6 form-group py-3 m-0">
                                    <input
                                        className={`form-control h-auto border-0 px-0 placeholder-dark-75 ${
                                            formState.errors.NR_CPF &&
                                            "is-invalid"
                                        }`}
                                        type="text"
                                        placeholder="* CPF"
                                        name="DS_CPF"
                                        ref={register({
                                            required: "Insira o seu CPF",
                                        })}
                                        maxLength={14}
                                        onChange={formatterCPF_CNPJ}
                                    />
                                    <div className="invalid-feedback">
                                        {formState.errors.NR_CPF
                                            ? formState.errors.NR_CPF.message
                                            : ""}
                                    </div>
                                </div>
                                <div className="col-md-6 form-group py-3 m-0">
                                    <input
                                        className={`form-control h-auto border-0 px-0 placeholder-dark-75 ${
                                            formState.errors.NR_RG &&
                                            "is-invalid"
                                        }`}
                                        type="text"
                                        placeholder="* RG"
                                        name="NR_RG"
                                        ref={register({
                                            required: "Insira o seu RG",
                                        })}
                                    />
                                    <div className="invalid-feedback">
                                        {formState.errors.NR_RG
                                            ? formState.errors.NR_RG.message
                                            : ""}
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6 form-group py-3 m-0">
                                    <input
                                        className={`form-control h-auto border-0 px-0 placeholder-dark-75 ${
                                            formState.errors.NR_TELEFONE_WPP &&
                                            "is-invalid"
                                        }`}
                                        type="tel"
                                        placeholder="* Telefone"
                                        name="NR_TELEFONE_WPP"
                                        ref={register({
                                            required: "Insira seu telefone",
                                        })}
                                    />
                                    <div className="invalid-feedback">
                                        {formState.errors.NR_TELEFONE_WPP
                                            ? formState.errors.NR_TELEFONE_WPP
                                                  .message
                                            : ""}
                                    </div>
                                </div>
                                <div className="col-md-6 form-group py-3 m-0">
                                    <input
                                        className={`form-control h-auto border-0 px-0 placeholder-dark-75 ${
                                            formState.errors.DS_CRECI &&
                                            "is-invalid"
                                        }`}
                                        type="text"
                                        placeholder="* CRECI"
                                        name="DS_CRECI"
                                        ref={register({
                                            required: "Insira seu CRECI",
                                        })}
                                        autoComplete="new-password"
                                    />
                                    <div className="invalid-feedback">
                                        {formState.errors.DS_CRECI
                                            ? formState.errors.DS_CRECI.message
                                            : ""}
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12 form-group py-3 m-0">
                                    <LazySelect
                                        className={`form-control h-auto border-0 px-0 placeholder-dark-75 ${
                                            formState.errors.ID_EQUIPE_VENDAS &&
                                            "is-invalid"
                                        }`}
                                        name="ID_ORGANIZACAO"
                                        ref={register({
                                            required:
                                                "Selecione uma organização",
                                        })}
                                        controller={ListarOrganizacaoController}
                                        getDS={(ds) => ds.DS_ORGANIZACAO}
                                        getKeyValue={(key) =>
                                            key.ID_ORGANIZACAO
                                        }
                                        {...FormMethods}
                                    >
                                        <option value="">
                                            * Selecione uma organizacão
                                        </option>
                                    </LazySelect>
                                    <div className="invalid-feedback">
                                        {formState.errors.ID_EQUIPE_VENDAS
                                            ? formState.errors.ID_EQUIPE_VENDAS
                                                  .message
                                            : ""}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 form-group py-3 m-0">
                                    <LazySelect
                                        className={`form-control h-auto border-0 px-0 placeholder-dark-75 ${
                                            formState.errors.ID_EQUIPE_VENDAS &&
                                            "is-invalid"
                                        }`}
                                        name="ID_EQUIPE_VENDAS"
                                        fatherName="ID_ORGANIZACAO"
                                        ref={register({
                                            required: "Selecione uma equipe",
                                        })}
                                        controller={
                                            ListarEquipesDeVendasSemLoginController
                                        }
                                        getDS={(ds) => ds.DS_EQUIPE_VENDAS}
                                        getKeyValue={(key) =>
                                            key.ID_EQUIPE_VENDAS
                                        }
                                        {...FormMethods}
                                    >
                                        <option value="">
                                            * Selecione uma equipe
                                        </option>
                                    </LazySelect>
                                    <div className="invalid-feedback">
                                        {formState.errors.ID_EQUIPE_VENDAS
                                            ? formState.errors.ID_EQUIPE_VENDAS
                                                  .message
                                            : ""}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6 form-group py-3 m-0">
                                    <input
                                        className={`form-control h-auto border-0 px-0 placeholder-dark-75 ${
                                            formState.errors.DS_SENHA &&
                                            "is-invalid"
                                        }`}
                                        type="password"
                                        placeholder="* Senha"
                                        name="DS_SENHA"
                                        ref={register({
                                            required: "Insira sua senha",
                                        })}
                                        autoComplete="new-password"
                                    />
                                    <div className="invalid-feedback">
                                        {formState.errors.DS_SENHA
                                            ? formState.errors.DS_SENHA.message
                                            : ""}
                                    </div>
                                </div>
                                <div className="col-md-6 form-group py-3 m-0">
                                    <input
                                        className={`form-control h-auto border-0 px-0 placeholder-dark-75 ${
                                            formState.errors
                                                .DS_SENHA_CONFIRMACAO &&
                                            "is-invalid"
                                        }`}
                                        type="password"
                                        placeholder="* Confirmação de Senha"
                                        name="DS_SENHA_CONFIRMACAO"
                                        ref={register({
                                            required: "Confirme sua senha",
                                            validate: (value) => {
                                                const { DS_SENHA } =
                                                    getValues(); // Obtém o valor do campo Senha
                                                return (
                                                    value === DS_SENHA ||
                                                    "As senhas não coincidem"
                                                ); // Validação
                                            },
                                        })}
                                        autoComplete="new-password"
                                    />
                                    <div className="invalid-feedback">
                                        {formState.errors.DS_SENHA_CONFIRMACAO
                                            ? formState.errors
                                                  .DS_SENHA_CONFIRMACAO.message
                                            : ""}
                                    </div>
                                </div>
                            </div>

                            <div className="form-group flex-grow-1 d-flex justify-content-center">
                                <button
                                    type="submit"
                                    disabled={registerUserLoading}
                                    className="btn btn-capys font-weight-bold px-9 py-4 my-3 d-flex g-2 align-items-center"
                                >
                                    Criar Conta
                                </button>
                            </div>
                            <div className="text-center mt-4">
                                <span className="text-muted">
                                    Já tem uma conta?
                                </span>{" "}
                                <button
                                    className="btn btn-link text-primary m-0 p-0 underline"
                                    disabled={registerUserLoading}
                                    onClick={handleBackToLogin}
                                    type="button"
                                >
                                    Entrar
                                </button>
                            </div>
                        </form>
                    </FormProvider>
                </>
            )}

            <ModalLance
                key="Modal"
                show={StatusModal}
                StateModalShow={setStatusModal}
                lstOrganizacoes={lstOrganizacoes}
                usuario={Usuario}
                tokenMSAL={tokenMSAL}
            />
        </div>
    );
}
